import React, { FC } from 'react'

import { IconIncomingCallProps } from './IconIncomingCall.types'
import * as Styled from './styles/IconIncomingCall.style'

import { nonThemeableRules } from '../../ruleSet'

const IconIncomingCall: FC<IconIncomingCallProps> = ({
  size = nonThemeableRules.defaultSize as number as IconIncomingCallProps['size'],
  isResponsive = false,
}: IconIncomingCallProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M26.05 12v10.012c0 .027.024.05.052.05h10.02' stroke='#E60000' strokeLinecap='round' strokeWidth='2' />
        <path d='M26.074 22.04 39.051 9.062' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M42.984 34.426c.02.07.032.14.032.21a6.803 6.803 0 0 1-.305 1.938c-.75 2.438-2.773 5.051-5.164 5.75-6.031 1.797-12.383-.043-18-2.863A24.258 24.258 0 0 1 8.773 28.766c-2.832-5.594-4.68-11.914-2.875-17.914.715-2.375 3.352-4.391 5.793-5.137l1.957-.516a.64.64 0 0 1 .766.414l1.547 4.528c.789 2.203 1.578 4.406 2.363 6.609l.063.172a.753.753 0 0 1-.25.848 8.831 8.831 0 0 1-2.54 1.335c-1.09.336-2.21.551-3.347.645a.731.731 0 0 0-.621.945 24.544 24.544 0 0 0 6.02 9.95 24.795 24.795 0 0 0 10 6.015.731.731 0 0 0 .94-.62 15.54 15.54 0 0 1 .661-3.349 8.69 8.69 0 0 1 1.34-2.52.744.744 0 0 1 .86-.25l.167.06 6.637 2.351c1.574.559 2.918 1.121 4.5 1.684.09.03.18.27.23.41Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconIncomingCall
